
import { defineComponent, PropType } from 'vue';

// Models
import { ContentBlock } from '../../CoffeePicker.model';

export default defineComponent({
  props: {
    block: {
      type: Object as PropType<ContentBlock>,
      required: true,
    },
  },
});
